module.exports = __webpack_public_path__ + "img/menu_language.1e570f7.svg";